import {useRef, useEffect} from 'react';
import styles from '../style.module.css';

interface ChatInputProps {
    value: string;
    onChange: (value: string) => void;
    onSubmit: (e: React.FormEvent) => void;
    isLoading: boolean;
    isOpen: boolean;
}

export function ChatInput({
    value,
    onChange,
    onSubmit,
    isLoading,
    isOpen,
}: ChatInputProps) {
    const inputRef = useRef<HTMLTextAreaElement>(null);

    // Focus input when panel opens
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => inputRef.current?.focus(), 100);
        }
    }, [isOpen]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit(e);
        }
    };

    return (
        <div className={styles.inputContainer}>
            <form onSubmit={onSubmit} className={styles.inputForm}>
                <textarea
                    ref={inputRef}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Ask Linda anything..."
                    className={styles.inputField}
                    rows={1}
                    disabled={isLoading}
                />
                <button
                    type="submit"
                    disabled={!value.trim() || isLoading}
                    className={styles.sendButton}
                >
                    Send
                </button>
            </form>
        </div>
    );
}
